/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    //     blocks.push({
    //         location: 'boot',
    //         blockType: BlockType.CODE,
    //         template: `
    //     'SPI setup for ${feature.getSettingValue('NAME')}
    //     ${feature.getSettingValue('NAME')}_CHANNEL=si2c_register("${feature.getSettingValue('NAME')}",${feature.getSettingValue('NAME')}_SDA,${feature.getSettingValue('NAME')}_SCL,yes)
    //     if ${feature.getSettingValue('NAME')}_CHANNEL<4 then
    //         ssi.channel=${feature.getSettingValue('NAME')}_CHANNEL
    //         ssi.enabled=NO
    //         ssi.baudrate=PL_SSI_BAUD_100kHz

    //         io.num=${feature.getSettingValue('NAME')}_SDA
    //         io.state=HIGH

    //         io.num=${feature.getSettingValue('NAME')}_SCL
    //         io.state=HIGH

    //         ssi.zmode = PL_SSI_ZMODE_ENABLED_ON_ZERO
    //         ssi.direction=PL_SSI_DIRECTION_LEFT
    //         ssi.domap = ${feature.getSettingValue('NAME')}_SDA
    //         ssi.dimap = ${feature.getSettingValue('NAME')}_SDA
    //         ssi.clkmap = ${feature.getSettingValue('NAME')}_SCL
    //         ssi.mode = PL_SSI_MODE_0

    //         ssi.enabled=YES
    //     end if

    //     'example for I2C transaction:
    //     'si2c_get(${feature.getSettingValue('NAME')}_CHANNEL)
    //     'si2c_start()
    //     'si2c_write(&h01)
    //     'si2c_stop()`,
    //     });

    //     blocks.push({
    //         location: 'GLOBAL_DIMS',
    //         blockType: BlockType.CODE,
    //         template:
    //             `dim ${feature.getSettingValue('NAME')}_CHANNEL as byte`,
    //     });

    //     blocks.push({
    //         location: 'GLOBAL_DECLARATIONS',
    //         blockType: BlockType.CODE,
    //         template:
    //             `declare ${feature.getSettingValue('NAME')}_CHANNEL as byte`,
    //     });

    //     blocks.push({
    //         location: 'GLOBAL_CONSTS',
    //         blockType: BlockType.CODE,
    //         template: `
    // const ${feature.getSettingValue('NAME')}_SDA=${Peripherals.getPinConstant(feature.getSettingValue('SDA'), feature.project.device.id)}
    // const ${feature.getSettingValue('NAME')}_SCL=${Peripherals.getPinConstant(feature.getSettingValue('SCL'), feature.project.device.id)}`,
    //     });

    return blocks;
};
